export default __webpack_public_path__ + "static/media/T124_A_BD.bec6dbb8.pdf";